/**
 * Created by danielr on 2/27/17.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var TwilioConfigModel = {};

    var KEYS = {
        ACCOUNT_SID: "accountSid",
        AUTH_TOKEN: "authToken",
        PHONE: "phone"
    };

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        TwilioConfigModel = RevisionedModel.extend({
            KEYS: KEYS,
            name: "TwilioConfigModel",
            defaults: {
                accountSid: "",
                authToken: "",
                phone: ""
            },

            validation:{
                "accountSid":[
                    {
                        required: true,
                        minLength: 1,
                        msg: "LEManager.dataSources.conversationSources.twilio.error.sid.required"
                    }
                ],
                "authToken":[
                    {
                        required: true,
                        minLength: 1,
                        msg: "LEManager.dataSources.conversationSources.twilio.error.token.required"
                    }
                ],
                "phone":[
                    {
                        required: true,
                        minLength: 1,
                        msg: "LEManager.dataSources.conversationSources.twilio.error.phone.required"
                    },
                    {
                        fn: function() {
                            var isPhoneValid = this.getPhone().match(/^\+(?:[0-9]●?){6,14}[0-9]$/g);
                            if (!isPhoneValid){
                                return "LEManager.dataSources.conversationSources.twilio.error.phone.invalid";
                            }
                        }
                    }
                ]
            },

            saveEnableValidation: {
                "accountSid":[
                    {
                        required: true,
                        minLength: 1,
                        msg: "LEManager.dataSources.conversationSources.twilio.error.sid.required"
                    }
                ],
                "authToken":[
                    {
                        required: true,
                        minLength: 1,
                        msg: "LEManager.dataSources.conversationSources.twilio.error.token.required"
                    }
                ],
                "phone":[
                    {
                        required: true,
                        minLength: 1,
                        msg: "LEManager.dataSources.conversationSources.twilio.error.phone.required"
                    }
                ]
            },

            initialize: function(attrs, options) {
                this.typeConfiguration = options.typeConfiguration;
            },

            getTypeConfiguration: function() {
                return this.typeConfiguration;
            },

            getAccountSid: function () {
                return this.get(KEYS.ACCOUNT_SID);
            },
            setAccountSid: function (sid) {
                this.set(KEYS.ACCOUNT_SID, sid);
            },
            getAuthToken: function(){
                return this.get(KEYS.AUTH_TOKEN);
            },

            setAuthToken: function(token){
                this.set(KEYS.AUTH_TOKEN, token);
            },
            getPhone: function(){
                return this.get(KEYS.PHONE);
            },
            setPhone: function(phone){
                this.set(KEYS.PHONE, phone);
            },
            validateSaveEnabled: function () {
                this.originalValidation = this.validation;
                this.validation = this.saveEnableValidation;

                var enable = this.isValid();

                this.validation = this.originalValidation;

                return enable;
            },
            isConfigStepComplete: function(){
                return !_.isEmpty(this.getAccountSid()) && !_.isEmpty(this.getAuthToken()) && !_.isEmpty(this.getPhone());
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    TwilioConfigModel.KEYS = KEYS;

    return TwilioConfigModel;
});

